/* eslint-disable */
export const AppData = {
    EntryTexts: {
      'A1': {
          'text': "Utopian is a one year old arts and culture magazine for which I was responsible for its editorial design. My goal was its layout to be simple, elegant and modern. It comprises of photo presentations positioned next to strong typography treatments and varying page layouts as to keep readers excited",
          'title': "UTOPIAN"
        },
      'B2': {
          'text': "Groove Records is a new greek record label which works in publishing and marketing of electronic music. Logotype requirements during the briefing were it to be distinctive and memorable to the public. In a frst glance, the logotype brings the leter G to mind, the initial of Groove. In retrospect it could also be a volume knob. This resemblance to the volume knob makes it dynamic and modern",
          'title': "GROOVE RECORDS"
        },
      'C2': {
          'text': "This is an album that was released for the womex festival. The album was distributed free of charge to festival’s volunteers.The band’s name is DAM and their frst vinyl bears the same name. The cover’s composition is a naked doll without legs inspired from one of their songs accompanied with the word dam in lowercase",
          'title' : "DAM" 
        },
      'C3': {
          'text': "The catalog of the established interior design firm Papaioannou presents company’s work in private properties. Photos of the designs, cover the biggest part of each of the catalog pages among a short description. This is in order for the clients to be able to focus on the work presented and not to be distracted by other unneccessary design elements",
          'title' : "PAPAIOANNOU INTERIOR DESIGN" 
       },
      'D4': {
          'text': "This is a poster about a speech in a public library. Speakers from diﬀerent countries talk about the fear of white space ,also known as, horror vacui and how it applies to the feld of graphic and motion design. A continuous line begins at the top section of the poster and ends at the botom, flling all space without leaving any empty. As a result this makes a true visualisation of the fear of the emptiness",
          'title' : "HORROR VACUI:THE FEAR OF WHITE SPACE" 
        },
      'E5': {
          'text': "This is the website of concert hall of lycabettus where theatrical plays and concerts take place. The aim of the website is to provide information to the public about the schedule and forthcoming events, as well as to facilitate online booking",
          'title' : "CONCERT HALL OF LYCABETTUS" 
        }
    },
    SlideshowImages: {
        'A1': [
            {'id': 0, 'name': "Utopian Magazine Cover", 'src': "/img/utopian/1.jpg"},
        {'id': 1, 'name': "Magazine Layout", 'src': "/img/utopian/2.jpg"},
        {'id': 2, 'name': "Image layout in magazine", 'src': "/img/utopian/3.jpg"},
            {'id': 3, 'name': "Full page magazine layout", 'src': "/img/utopian/4.jpg"}
      ],
       'B2': [
            {'id': 0, 'name': "groove records label", 'src': "/img/groove/1.jpg"},
        {'id': 1, 'name': "groove records uv", 'src': "/img/groove/2.jpg"},
        {'id': 2, 'name': "groove records offices", 'src': "/img/groove/3.jpg"},
            {'id': 3, 'name': "record label business card", 'src': "/img/groove/4.jpg"}
      ],
       'C2': [
        {'id': 0, 'name': "Vinyl Cover", 'src': "/img/dam.jpg"}
       ],
       'C3': [
            {'id': 0, 'name': "Interior Design catalog cover", 'src': "/img/interior-design/1.jpg"},
        {'id': 1, 'name': "interior design catalog layout", 'src': "/img/interior-design/2.jpg"},
        {'id': 2, 'name': "interior design modern layout magazine", 'src': "/img/interior-design/3.jpg"},
      ],
       'D4': [
            {'id': 0, 'name': "whitespace poster", 'src': "/img/horror/1.jpg"},
        {'id': 1, 'name': "event poster", 'src': "/img/horror/2.jpg"},
        {'id': 2, 'name': "black and white poster", 'src': "/img/horror/3.jpg"},
        ]
        ,
       'E5': [
            {'id': 0, 'name': "website ui over the fold", 'src': "/img/luc/1.jpg"},
            {'id': 1, 'name': "website ui events", 'src': "/img/luc/2.jpg"},
            {'id': 2, 'name': "website ui event calendar", 'src': "/img/luc/3.jpg"},
            {'id': 2, 'name': "website ui event information", 'src': "/img/luc/4.jpg"},
            {'id': 2, 'name': "website ui mobile booking", 'src': "/img/luc/5.jpg"},
            {'id': 2, 'name': "website ui mobile calendar", 'src': "/img/luc/6.jpg"},
          ]
    }
}
